import AdUnitsSelect from './ui/AdUnitsSelect';
import ContentCategorySelect from './ui/ContentCategorySelect';
import ContentPublicationSelect from './ui/ContentPublicationSelect';
import ContentStatusSelect from './ui/ContentStatusSelect';
import DatePicker from './ui/DatePicker';
import FormatSelect from './ui/FormatSelect';
import GroupSwitch from './ui/GroupSwitch';
import ReferralSitesSelect from './ui/ReferralSitesSelect';
import SiteDateSwitch from './ui/SiteDateSwitch';
import SiteSelect from './ui/SiteSelect';

const PageFilter = {
  ContentCategorySelect,
  ContentPublicationSelect,
  ContentStatusSelect,
  DatePicker,
  SiteSelect,
  FormatSelect,
  GroupSwitch,
  SiteDateSwitch,
  AdUnitsSelect,
  ReferralSitesSelect,
};

export default PageFilter;
